const $ = require('jquery');
const util = require('./util.js');

var restInputSelector = 'input, select, textarea';

var scl_modalGeneric = (function () {
    var self = {
        'el': ''
        , 'options': {
            'headerText': ''
            , 'bodyText': ''
            , 'showCloseButton': false
            , 'callbackOpen': null
            , 'callbackClose': null
            , 'modal': null
        }
        , 'open': function (options) {
            this.options = $.extend(this.options, (options || {}));
            this.createModal();
            var _this = this
            this.el.modal();
            if (this.options.callbackOpen && typeof this.options.callbackOpen == 'function') {
                this.el.on('shown', function () {
                    _this.options.callbackOpen();
                });
            }
        }
        , 'close': function (obj) {
            obj = obj || null;

            if (obj) {
                if (obj.headerText) {
                    this.options.headerText = obj.headerText;
                    this.setHeaderText(this.options.headerText);
                }
                if (obj.bodyText) {
                    this.options.bodyText = obj.bodyText;
                    this.setBodyText(this.options.bodyText);
                }
                if (obj.callbackClose) {
                    this.options.callbackClose = obj.callbackClose;
                }
            }

            var _this = this;
            setTimeout(function () {
                _this.el.modal('hide');
                if (_this.options.callbackClose && typeof _this.options.callbackClose == 'function') {
                    _this.el.on('hidden', function () {
                        _this.el.remove();
                        _this.options.callbackClose();
                    });
                }
            }, 1500);
        }
    };
    return self;
})();



/****************
 
 UTILITY code to manipulate DOM and have dynamic tree forming forms
 
 
 *******************/
var ckNameSeparator = '___';


// vars used in orginal serializeArray
var
        rselectTextarea = /select|textarea/i,
        rinput = /color|date|datetime|email|hidden|month|number|password|range|search|tel|text|time|url|week/i,
        rformElements = /textarea|select|input/i
        ;
var debugGlobal;


var ckeditorConfig =
        {
            language: 'fr',
            width: 700,
            height: 350,
            resize_enabled: true,
            toolbar: [
                ['Source'],
                ['Table'],
                ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'SpellChecker', 'Scayt'],
                ['Undo', 'Redo', '-', 'SelectAll', 'RemoveFormat'],
                ['Link', 'Unlink'],
                ['NumberedList', 'BulletedList', 'TextColor', 'BGColor'],
                ['Styles', 'Format', 'Font', 'FontSize', 'JustifyLeft', 'JustifyCenter', 'JustifyRight',
                    'JustifyBlock', 'Bold', 'Italic', 'Underline', 'Strike', '-', 'Subscript', 'Superscript']
            ]
        }
;

//// beginning of refactor - to make webpack work
var scl_templates = 
    {
        modalContainer : '<span></span>', 
        headerContent  : '<span></span>', 
        template  : '<span></span>', 
        buttonCLose  : '<span></span>', 
        template  : '<span></span>' 

    };

var ckeditorConfigFullHtml =
        {
            language: 'fr',
            width: 700,
            height: 350,
            resize_enabled: true,
            toolbar: [
                ['Source'],
                ['Table'],
                ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'SpellChecker', 'Scayt'],
                ['Undo', 'Redo', '-', 'SelectAll', 'RemoveFormat'],
                ['Link', 'Unlink'],
                ['NumberedList', 'BulletedList', 'TextColor', 'BGColor'],
                ['Styles', 'Format', 'Font', 'FontSize', 'JustifyLeft', 'JustifyCenter', 'JustifyRight',
                    'JustifyBlock', 'Bold', 'Italic', 'Underline', 'Strike', '-', 'Subscript', 'Superscript']
            ],
            fullPage: true
        }
;



var ckeditorSimpleConfig =
        {
            language: 'fr',
            width: 700,
            height: 350,
            resize_enabled: true,
            toolbar: [
                ['Source'],
                ['PasteFromWord'],
                ['BulletedList', 'TextColor'],
                ['Bold', 'Italic']
            ]
        }
;



//// global to restfulFormSubmit
var global_exitFormChanged = false;
//var submitted = false;

function resetGlobalExitFormChanged() {
    global_exitFormChanged = false;
}


function initRestFormPage(elem) {
    // Attribute submit event on the Save Button
    $('.save_btn').click(function () {
        // pass trigger button reference (for sc_redirect)
        $(elem).trigger('submit', $(this));
    });
    initRestfulForm(elem);
}
function initRestfulForm(elem) {
    $('.scl_entity_el', elem).each(function () {
        // INIT array hooks 
        // select ancestor ref_array, increment index of new element
        var parentArrayRef = $(this).closest('.scl_array_ref');
        parentArrayRef.data('array_length', 1);
        $(this).data('array_idx', 0);
    });

    enableDeleteButton($('.deleteb', elem));

    $('.first_focus:visible', elem).eq(0).trigger('focus'); // first visible focusable

    $('button', elem).button();

    /*        $('.date',elem).datepicker({
     //                                        inline: true,
     dateFormat: 'yy-mm-dd'
     });
     */
    // note: duplicate Button also duplicates behavior, (stores it in cache)
    // so it needs to be the last command (except for ckeditor)
    enableDuplicateButton($('.duplicate', elem));

    // ckeditor 
    //  $('textarea.editor',elem).ckeditorId.ckeditor(function(){},ckeditorConfig);

    handleInputChange($('input[type=checkbox]'));




    window.onbeforeunload = alertExit;
    var message = "Si vous quittez cette page, les données qu'elle contient ne seront pas sauvegardées";
    $(restInputSelector, elem).change(function () {
        global_exitFormChanged = true;
        //$('body').css({'backgroundColor':'#FFEAEA'})
    });
    // if prefill in URL, global_exitFormChanged = true;
    if (util.parseQueryString(window.location.search)['prefill']) {
        global_exitFormChanged = true;
        //$('body').css({'backgroundColor':'#FFEAEA'})
    }

    ////////////////////// RESET - TODO
    /////////// now done in DEFAULT success callback
    //$(elem).submit(function(){
    //    global_exitFormChanged = false;
    //    submitted = true;
    //$('body').css({'backgroundColor':'#FFFFFF'})
    ///});
    /////////////////////////////

    function alertExit(event) {
        if (global_exitFormChanged) {
            return message;
        } else {
            event.cancelBubble = true;
        }
    }

    ///////////// DELETE BUTTON    
    $('#delete_entity_btn').click(function () {
        var entity_name = $('form.scl_rest_form').not('.search_form').attr('serviceIdentifier');
        var delete_confirm_msg = "Voulez-vous vraiment supprimer ce(t) " + entity_name + "?";
        if (confirm(delete_confirm_msg)) { // Clic sur OK
            global_exitFormChanged = false;
            $.ajax({
                type: 'DELETE',
                url: getRestServiceUri($('form.scl_rest_form')),
                success: function (dataReceived) {
                    // deserialize response
                    var dataRecObj = $.parseJSON(dataReceived);
                    if (dataRecObj && dataRecObj['_sc_redirect']) {
                        window.location.href = dataRecObj['_sc_redirect'];
                    } else {
                        window.location.href = 'index.php?page=MyDaily';
                    }
                },
                // handle 412 error - convention is that the msg is straight up in the body
                error: function () {
                    alert('La suppression ne fonctionne pas, veuillez contacter un administrateur SophiaCloud')
                },
            });
        }
    });
}


function handleInputChange(elem) {
    $(elem).change(function () {
        $(this).addClass('scl_was_changed');
    });
}



function cacheClone(elem, removeOriginal) {
//function getFirstRowClone( arrayRef, removeOriginal ){
    if ($(elem).data('rowClone') == null) {

        // get the TR corresponding to the button, and then select the previous TR
        //var rowToDuplicate = $('.scl_entity_el:first',arrayRef);
        if (!$(elem).hasClass('scl_array_ref')) {
            throw "cacheClone needs to be called on Array Ref";
        }

        if ($(elem).hasClass('scl_array_dep')) {
            // then we need to take the clone from the scl_array_main
            entityName = getEntityName($(elem));
            mainArrayRef = $('.scl_array_main[title=' + entityName + ']', $(elem).closest('.scl_entity_el'));
            /// just in case the main arrayref hasn't had its clone
            cacheClone(mainArrayRef);
            otherClone = mainArrayRef.data('rowClone').clone(true);
            otherClone.data('base_id', Math.floor(Math.random() * 100000));
            otherClone.attr('id', otherClone.data('base_id') + '_0');
            $(elem).data('rowClone', otherClone);
            return $(elem);
        }


        var rowToDuplicate = $('.scl_entity_el:first', elem);
        /// not ready for now............... because if called after fillForm... PB
        ////var rowToDuplicate = $('.scl_entity_el',elem);
        if (rowToDuplicate.length != 1) {
            throw "needs to be exactly 1 entity_el when cloning";
        }

        // if it doesn't have an id, add it for later use
        // create random base (since arrays can be multiple times in a DOM, you can't use their title)
        rowToDuplicate.data('base_id', Math.floor(Math.random() * 100000));
        rowToDuplicate.attr('id', rowToDuplicate.data('base_id') + '_0');

        var rowClone = rowToDuplicate.clone(true);





        // reset values
        $(restInputSelector, rowClone).not('.scl_preserve_value').each(function () {
            $(this).val('');
        });


        if (removeOriginal || $(elem).hasClass('scl_optional')) {
            //rowToDuplicate.parent().addClass('scl_entity_anchor');
            rowToDuplicate.parent().prepend('<div class="scl_entity_anchor"></div>');
            rowToDuplicate.remove();
        }

        $(elem).data('rowClone', rowClone);
    }

    return $(elem);

}



/////////////////// Utility function to enable form element duplication
////// while maintaining some refs to be used for serialization
////// note: scl_array_ref should always be in the parent of array_idx
function enableDuplicateButton(elem) {
    $(elem).each(function () {

        // create closure where you store the cached object

        var parentArrayRef = $(this).closest('.scl_array_ref');
        if (parentArrayRef.hasClass('scl_array_dep')) {
            // then we are in a case where scl_array_ref is split 
            // and we must find the entity_el description in the scl_array_main
            var mainArrayRef = $('.scl_array_main', parentArrayRef.parent().closest('.scl_array_ref'));

            //parentArrayRef.data('rowClone', getFirstRowClone(mainArrayRef,true));
            cacheClone(parentArrayRef, true);
        } else {

            //// TODO: make framework unified -i.e. ALWAYS REMOVE the original mold => if no data - no element
            //parentArrayRef.data('rowClone', getFirstRowClone(parentArrayRef),true);
            //parentArrayRef.data('rowClone', getFirstRowClone(parentArrayRef));
            cacheClone(parentArrayRef, false);
        }


        // ON CLICK
        // ADD ONE MORE ENTITY - DEEP COPY - UPDATE ARRAY_REF
        $(this).click(function () {
            duplicateEntity($(this), {'user_click': true});
        });
    });

}


function enableDeleteButton(elem) {
    $(elem).each(function () {
        $(this).click(function (e) {
            e.preventDefault();
            var parentEntity = $(this).closest('.scl_entity_el');

            // add hidden input indicating that element is to be deleted in data_operator
            // hence, scl_entity_el still submitted
            $('<input type="hidden" name="wasdeleted"></input>')
                    .val(1)
                    .appendTo(parentEntity);

            // hide entity
            $(this).closest('.scl_entity_el').slideUp(800);
        });
    });
}

function duplicateEntity(elem, options) {
    // select ancestor ref_array, increment index of new element

    if ($(elem).hasClass('scl_array_ref')) {
        var parentArrayRef = $(elem);
    } else {
        var parentArrayRef = $(elem).closest('.scl_array_ref');
    }

    var currentIdx = parentArrayRef.data('array_length');

    /// initialization de l'index - faire attention avec les parentArrayRef et les scl_array_dep
    /// comportement different si le parent est un scl_array_dep
    if (parentArrayRef.hasClass('scl_array_dep')) {
        var entity_name = getEntityName(parentArrayRef);
        ////// there could be many tags for entity_name, but quick hack for borealis ckeditor disappearing on duplicate twice
        var mainArrayRef = $('[title=' + entity_name + '].scl_array_main');
        currentIdx = mainArrayRef.data('array_length');

        if (typeof (currentIdx) == 'undefined') {
            currentIdx = 0;
        }
        // update array_length of main since we want to avoid conflict for any CKeditor created in ANY dep
        mainArrayRef.data('array_length', currentIdx + 1);
    } else {
        if (typeof (currentIdx) == 'undefined') {
            //// first time we duplicate
            currentIdx = 0;
        }

        // update array_length
        parentArrayRef.data('array_length', currentIdx + 1);

    }

    //////////////////////// PREPARE NEW CLONE
    // create and insert cloned sub section
    var newClone = parentArrayRef.data('rowClone').clone(true);

    // create new id
    newClone.attr('id', newClone.data('base_id') + '_' + currentIdx);

    // hack for CKeditor, which needs to have a unique name
    $('.scl_name_as_id', newClone).each(function (i, elem) {
        var str = elem.name;
        var baseName = str.split(ckNameSeparator, 1)[0];
        //// update name with trailing indice corresponding to entity
        elem.name = baseName + ckNameSeparator + currentIdx;
    });
    // attach value of index
    newClone.data('array_idx', currentIdx);

    /////////////////////// PLACE NEW CLONE
    /* On récupère le targetEl, il y a 3 comportements pour placer le entity_el : append dans fragment, append dans targetEl ou after targetEl */
    /* duplicate after may not work with fragment ??? */
    if (options && options.fragment) {
        // Javascript version doesn't keep data attached ?
        //options.fragment.appendChild(newClone.get(0));
        // JQuery version
        options.fragment.append(newClone);
    } else {
        var targetEl;
        if (parentArrayRef.data('getDuplicateTargetEl') != undefined) {
            targetEl = parentArrayRef.data('getDuplicateTargetEl')(newClone, parentArrayRef);
        } else {
            targetEl = getDuplicateTargetEl(elem, parentArrayRef);
        }
        if (parentArrayRef.hasClass('duplicate_after') || targetEl.hasClass('scl_entity_el')) {
            targetEl.after(newClone);
        } else {
            targetEl.append(newClone);
        }
    }
    // animate on user click
    if (options && options.user_click) {
        ////// PB: with frais_evenement sur index.php?page=Evenement&evenement_id=3UdzgOw1kfN45i92Lzk3p7 : 'overflow:hidden'
        //newClone.hide().slideDown();
    }
    activateNewClone(newClone, options);

    ///////// GENERIC functions to run on every scl_entity_el
    if (typeof (parentArrayRef.data('applyToEntityEl')) != 'undefined') {
        parentArrayRef.data('applyToEntityEl')(newClone, options);
    }


    return newClone;

}
;

function getDuplicateTargetEl(elem, context) {
    var lastEl;
    if ($(elem).data('duplicate_last') != undefined) { // LEGACY CODE
        lastEl = $(elem).data('duplicate_last')(newClone);
        targetEl = lastEl;
    } else {
        var allEl = $('.scl_entity_el', context);
        if (allEl.length == 0) {
            // if empty, then there should be 1 anchor
            // and anchor is to have the flexibility to put things before or after entity_els
            var anchor = $('.scl_entity_anchor', context);
            if (anchor.length == 0) {
                lastEl = context;
            } else {
                lastEl = anchor;
            }
        } else {
            lastEl = allEl
                    .filter(':first') // first el under .scl_array_ref - semi-direct descendant
                    .siblings('.scl_entity_el')
                    .addBack() // also first - because there might not be siblings if lone element
                    .filter(':last');
        }
        targetEl = lastEl;
    }
    return $(targetEl);
}


function activateNewClone(elem, options) {
    options = options || {};
    ///////////////////////// HACKS to ensure duplication happens correctly based on expected behavior
    // apply button to duplicates cause, otherwise the UI effects get messed up
    //$('button',elem).each(function(){ $(this).button(); });

    /***************** TODO: refactor for webpack
    require(['fileUploader'], function (fileUploader) {
        // upload buttons (fake buttons overlayed on top of input type=file
        $('.upload_div', elem).each(function () {
            fileUploader.enableUploadButton($(this));
        });
    })
    *********************/


    $('.deleteb', elem).each(function () {
        enableDeleteButton($(this));
    });
    /*************** TODO: refactor for webpack
    if (typeof (options.ignore_ckeditor) == 'undefined') {
        // ckeditor initialization for scl_entity (note: even first element is a clone, hence goes through this function)

        if (options.activateCloneOption && options.activateCloneOption.ckCallback) {
            $('textarea.editor', elem).each(function () {
                $(this).ckeditor(options.activateCloneOption.ckCallback, ckeditorConfig);
            });
        } else {
            $('textarea.editor', elem).each(function () {
                $(this).ckeditor(function () {}, ckeditorConfig);
            });
        }
    }
    ****************/
    $('.date_picker, .date_picker_dob', elem).datepicker('destroy');
    $('.date_picker, .date_picker_dob', elem).removeAttr('id'); // HACK : destroy ne supprime pas l'id
    $('.date_picker, .date_picker_dob', elem).datepicker();

    ////// make sure not sent if not touched    
    handleInputChange($('input[type=checkbox]', elem));


    // Tooltip
    $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
    });
    /*var tableTags = ['TD', 'TH', 'TR', 'THEAD', 'TBODY', 'TFOOT'];
     $('[data-toggle="tooltip"]').each(function(){
     var options = {};
     if(tableTags.indexOf($(this).prop("tagName")) != -1){
     options['container'] = 'body';
     }
     if($(this).data('title')){
     options['title'] = $(this).data('title');
     }
     $(this).tooltip(options);
     });*/

    // Slider

    $('.input_slider', elem).slider({
        range: 'min',
        slide: function (event, ui) {
            thisName = $(this).attr('name');
            $('input[name=' + thisName + ']', elem).val(ui.value);
        }
    });

    return elem;

}




/***************************************************
 UTILITY code for data SERIALIZATION and AJAX submission
 **********************************************/


//TAG nodes of the tree with their depth of scl_array_ref/scl_entity_el 
//- one of the issues otherwise is name space collision ( same attribute name of different entities)
function recursiveDepthFill(elem, recursiveDepth) {//, cleanFlag){
    // Note: elem should be either scl_array_ref or scl_entity_el or restInputEl
    // Algo: flood each el, keep going down and updating the depth of els as we go down

    /* TODO if needed - FOR NOW, I don't think DOM modification should invalidate current recursiveDepthFill
     cleanFlag = (typeof cleanFlag === "undefined") ? false : true;
     // init - clear previous depth
     if(cleanFlag){
     
     }*/

    $(elem).each(function () {

        //////////// TREAT ELEMENT
        //// update the recursiveDepth
        var elRecursiveDepth = $(this).data('recursiveDepth');
        if (
                typeof (elRecursiveDepth) == 'undefined'
                || elRecursiveDepth <= recursiveDepth // = might be previously set, but still need to access lower modified elements
                //|| elRecursiveDepth < recursiveDepth
                ) {
            $(this).data('recursiveDepth', recursiveDepth);
        } else {
            return; // if we've seen it before and shallower then no point in going further, treated through other recursion path
        }


        /////////// GO DEEPER IN TREE
        var nextElsToProcess;
        if ($(this).hasClass('scl_entity_el')) {
            nextElsToProcess = $('.scl_array_ref', this);
            //// apply the recursion to all nextEls
            recursiveDepthFill(nextElsToProcess, recursiveDepth + 1);
        } else if ($(this).hasClass('scl_array_ref')) {
            nextElsToProcess = $('.scl_entity_el'
                    + ',' + restInputSelector
                    , this);
            /// the entity els stay at the level of the parent scl_array_ref
            recursiveDepthFill(nextElsToProcess, recursiveDepth);
        } else {
            return;
        }

    });

}
;

//// applied on scl_array_ref // this assumes recursiveDepth is up to date 
function getChildrenEntityEl(elem) {
    var thisArrayRef = $(elem);
    if (!thisArrayRef.hasClass('scl_array_ref')) {
        throw 'Erreur getChildrenEntityEl : oups... should be scl_array_ref';
    }

    var thisDepth = thisArrayRef.data('recursiveDepth');

    var resultWrapperSet =
            $('.scl_entity_el', thisArrayRef)
            .filter(function (i, elem) {
                if ($(elem).data('recursiveDepth') == thisDepth) {
                    return 1;
                } else {
                    return 0;
                }
            });

    return resultWrapperSet;
}
;


//// applied on scl_array_ref // this assumes recursiveDepth is up to date 
function getEntityName(elem) {

    var entityName = 'scl_name_not_set'; // for easy debugging
    var thisTag = $(elem).get(0).tagName;
    if (thisTag == 'TABLE') {
        // (hack: summary in table) - doesn't support name att
        entityName = $(elem).attr('summary');
    } else if (thisTag == 'TR' || thisTag == 'UL' || thisTag == 'LI' || thisTag == 'DIV' || thisTag == 'TBODY') {
        entityName = $(elem).attr('title');
    } else if (elem.tagName == 'INPUT') {
        entityName = $(elem).attr('name');
    }

    return entityName;
}



function getRestServiceUri(elem, uriOptions) {
    // get base service associated with form
    var uri;
    function append(uri, option_str) {
        if (uri.substr(-1) != '?') {
            return uri + '&' + option_str;
        } else {
            return uri + option_str;
        }
    }

    if (uriOptions != null) {
        uri = uriOptions['base_uri'] || $(elem).attr('action');
    } else {
        uri = $(elem).attr('action');
    }
    if (uri == null)
        return false;
    if (uriOptions != null) {
        var copyOptions = $.extend(true, {}, uriOptions);
        delete  copyOptions['base_uri'];
        if ($.param(copyOptions) != "") { // BUGFIX Gautier : si pas d'arguments, pas de & dans l'url
            uri = append(uri, $.param(copyOptions));
        }
    } else if ($(elem).data('uriParams') != null) {
        uri = append(uri, $.param($(elem).data('uriParams')));
    }
    return uri;
}


// called specifying dummysubmit=1 in URL
function dummySubmit(elem, isTest) {
    elem.submit(function (event) {
        event.preventDefault();
        if (isTest) {
            $('#sandbox').append($('<div class="qunit_submit_success"></div>'));
        } else {
            // prevent the default to hijack it

            var formData = retrieveFormObject($(this));

            var service_data = {'type': 'sc_object',
                data: formData
            };

            // serialize
            var dataToSend = JSON.stringify(service_data);

            console.log('do nothing - '
                    + $(this).attr('restFormHttpMethod') + ' - '
                    + dataToSend
                    );
        }

    }); // close .submit() 
}

function restfulSubmit(elem, submitOptions) {

    if (typeof (submitOptions.successCallback) == 'undefined' || typeof (submitOptions.errorCallback) == 'undefined') {
        throw "ERREUR RestfulSubmit options : check your callbacks !";
    }
    elem.submit(function (event, trigger) {

        // prevent the default to hijack it
        event.preventDefault();

        // call form spec behavior if any
        // like form validation
        if ($(this).specificFormBehavior) {
            // if this method returned false
            // then something went wrong
            // proper reaction to be filled out later

            // resultForm = {status: 'false si pb', allpb: [ 'ref_dom': $(field_name), 'msg': 'Merci de renseigner un email valide' ]}
            var resultForm = $(this).specificFormBehavior();

            // si champ obligatoire non rempli ou format non respecté
            if (!resultForm['status']) {

                // création de l'array de message d'erreur
                var errorMsg = [];
                for (var i = 0; i < resultForm['allpb'].length; i++) {
                    errorMsg.push('- ' + resultForm['allpb'][i]['msg']);
                }

                if ($(this).specificErrorBehavior) {
                    return $(this).specificErrorBehavior(resultForm);
                } else {
                    alert(errorMsg.join('\n'));
                    return false;
                }
            }
        }

        // store reference to the form
        var formRef = $(this);

        var formData = retrieveFormObject($(this));

        if(submitOptions.enrichFormData){
            formData = submitOptions.enrichFormData(formData);
        }

        var service_data = {'type': 'sc_object',
            data: formData
        };

        // serialize
        var dataToSend = JSON.stringify(service_data);

        // clean the DOM of serializeForm data
        $('.scl_array_ref,.scl_entity_el').removeData('serializeForm');

        // if it's the first time we call it, then we are in creation mode
        // and we set the method to post
        if ($(this).attr('restFormHttpMethod') == null) {
            $(this).attr('restFormHttpMethod', 'POST');
        }

        if (typeof (submitOptions) == 'undefined') {
            submitOptions = {};
        }

        var uriOptions = {};
        if(submitOptions.uriOptions){
            uriOptions = submitOptions.uriOptions;
        }

        // send data REST style
        $.ajax({
            type: $(this).attr('restFormHttpMethod'),
            url: getRestServiceUri($(this), uriOptions),
            contentType: 'application/json',
            data: dataToSend,
            dataType: null,
            success: submitOptions.successCallback,
            // handle 412 error - convention is that the msg is straight up in the body
            error: submitOptions.errorCallback,
            beforeSend: submitOptions.beforeSendCallback
        });
    }); // close .submit() 
}



function displayPopoverError(elem, msg) {
    $(elem).css({'border': '2px solid red', 'boxSizing': 'border-box'});
    $(elem).popover({
        'title': 'Erreur',
        'content': msg,
        'placement': 'top',
        'trigger': 'focus',
        'container': $(elem).parent()
    }).popover('show');
}
function dynamicValidation(elem) {
    $(elem).each(function () {
        var elem = this;
        /// validate when changed
        $(elem).change(function () {
            // verification dynamique
            var res = $.fn.specificFormBehavior();
            var dynamicRes = {status: true, allpb: []};
            // si il y a des erreurs sur la page
            if (typeof (res) != 'undefined') {
                $(res.allpb).each(function (i) {
                    // si l'élément modifié contient une erreur, on la stocke
                    if (this.ref_dom.attr('name') == $(elem).attr('name')) {
                        dynamicRes.allpb.push(this);
                        dynamicRes.status = false;
                    }
                });
                // si l'élément modifié ne contient plus d'erreur, on enleve le popover
                if (dynamicRes.status) {
                    $(elem).css('border', 'none').popover('destroy');
                }
                // sinon on applique errorbehavior
                else {
                    $.fn.specificErrorBehavior(dynamicRes);
                }
            }
        });
    });
}



function retrieveFormObject(elem) {
    //debugGlobal =  $(elem).data('serializeForm');

    // the form is a level above the scl_array_ref containing the data
    var rootRef = $('.scl_root_ref', elem);

    var formObj = retrievePayloadObject(rootRef, 1);

    // clean the DOM of serializeForm data
    // $('.scl_array_ref,.scl_entity_el').removeData('serializeForm');

    // assuming elem is the form selector
    return formObj;
}



function retrievePayloadObject(elem, fromDepth) {

    if (!$(elem).hasClass('scl_array_ref')) {
        alert("ERRREUR de construction d'objet");
        return {};
    }

    //// update recursiveDepth
    recursiveDepthFill($(elem), fromDepth);

    /// then init a map of indices to keep track of display_order
    $('.scl_array_ref', $(elem).parent()).each(function () {
        var elPositionMap = {};
        var thisArrayRef = $(this);
        var childrenEntityEl = getChildrenEntityEl(thisArrayRef);
        // retrieve valid count and index at same time
        var validElCount = childrenEntityEl
                .filter(function (index) {
                    /// ignore if element was deleted
                    return $(this).children('[name=wasdeleted]').length == 0;
                })
                .each(function (i, elem) {
                    elPositionMap[$(elem).attr('id')] = i;
                }).length;

        /// init index of deleted, starting at validElCount
        childrenEntityEl
                .filter(function (index) {
                    /// ignore if element was deleted
                    return $(this).children('[name=wasdeleted]').length != 0;
                })
                .each(function (i, elem) {
                    $(elem).appendTo($(thisArrayRef));
                    elPositionMap[$(elem).attr('id')] = validElCount + i;
                });
        thisArrayRef.data('elPositionMap', elPositionMap);
    });


    // only select the inputs relative to the form we are looking at    
    // if there's a type file it just means there was no file uploaded
    // as when it is uploade a reference to the file_id is what gets saved in a restfulForm    
    attachInputDataToArrayRef($(restInputSelector, elem).not(".ignore_input").not("[type=file]"));

    // since the algo works by looking up the parent, we have to avoid the root node
    // note - entityObj undefined error otherwise - which can be seen if unintended inputs are selected
    attachArrayRefData($('.scl_array_ref:not(.scl_root_ref,.ignore_input)', elem));

    return $(elem).data('serializeForm');

}




/**
 // leaves to nodes 
 * init scl_array_ref
 * init scl_entity_el - attach to parent scl_array_ref
 * input to scl_entity_el
 ***/
function attachInputDataToArrayRef(elem) {

    // TODO: treat the special case of radio buttons later
    // go through each input el
    $(elem).each(function () {

        ////////////////////////////// RETRIEVE REF AND INIT
        // init data('serializeForm')
        var parentArrayRef = $(this).closest('.scl_array_ref');
        if (parentArrayRef.attr('title') == 'feed_borealis') {
            var dudebug = 0;
        }


        if (parentArrayRef.data('serializeForm') == null) {
            ///// INIT scl_array_ref
            parentArrayRef.data('serializeForm', []);
        }
        var entityEl = $(this).closest('.scl_entity_el');

        if (entityEl.data('serializeForm') == null) {
            ///// INIT scl_entity_el and connect to scl_array_ref
            var arrayRefData = parentArrayRef.data('serializeForm');
            var currentIdx = parentArrayRef.data('elPositionMap')[ entityEl.attr('id') ];

            var initObj;

            //////// TODO: gerer le dep dynamic
            if (entityEl.hasClass('scl_view_options')) {
                // init ref


                // on creating digest 
                // be systematic and save array_label id as array_label


                //// array_label used for scl_array_dep
                initObj = {'view_options_scl_json':
                            [{'display_order': currentIdx,
                                    'array_label': parentArrayRef.attr('id')
                                }]
                };
                //// mechanism for duplicating the containing array
                if (parentArrayRef.data('scl_array_template')) {
                    // store the id of the parentArrayRef, as there might be clones
                    //initObj.view_options_scl_json[0]['scl_array_dep_id'] = parentArrayRef.attr('id');
                    initObj.view_options_scl_json[0]['scl_array_template'] = parentArrayRef.data('scl_array_template');
                }

            } else {
                initObj = {};
            }

            entityEl.data('serializeForm', initObj);
            arrayRefData[ currentIdx ] = entityEl.data('serializeForm');
        }

        //////////////////////// IF NOT EMPTY, get value from DOM and put it in entityObj
        if (
                ($(this).attr('type') == 'checkbox' &&
                        ///// hack for borealis to avoid sending empty checkboxes
                                //// to be changed later 
                                        ($(this).hasClass('scl_was_changed')
                                                ///// must still send info if checked
                                                || $(this).prop('checked') == true)
                                        )
                                ||
                                (
                                        $(this).attr('type') != 'checkbox' &&
                                        ($(this).attr('type') == 'radio'
                                                || $(this).val() != ''
                                                || $(this).data('nullflag'))
                                        )
                                ) {

                    /////////////////////
                    // get JS obj which will 
                    var entityObj = entityEl.data('serializeForm');
                    /////////////////////// entityObj is our hook

                    var thisName = this.name;
                    if ($(this).hasClass('scl_name_as_id')) {
                        // need to modify name if it's of the class editor
                        // cause CKeditor has unique names...
                        // hack: since they use name more like an id
                        // names on ckeditor are: "realname_id" with ckNameSeparator == '_'
                        var str = this.name;
                        // get "realname"
                        thisName = str.split(ckNameSeparator, 1)[0];
                    }

                    if ($(this).attr('type') == 'checkbox') {
                        if ($(this).prop('checked') == true) {
                            entityObj[thisName] = 1;
                        } else {
                            entityObj[thisName] = 0;
                        }
                    } else if ($(this).attr('type') == 'radio') {
                        if ($(this).prop('checked') == true) {
                            entityObj[thisName] = $(this).val();
                        }
                    } else if (thisName.match(/^date_/g) !== null || thisName == 'dob') { // Hack for date of birth
                        entityObj[thisName] = util.datetimeToInt($(this).val());
                    } else if ($(this).hasClass('realnumber')) {
                        if (!$(this).data('realnumber')) {
                            $(this).data('realnumber', $(this).val());
                        }
                        entityObj[thisName] = $(this).data('realnumber');
                    } else if ($(this).data('nullflag')) {
                        entityObj[thisName] = 'null';
                    } else {
                        // retrieve input data and put in ref to entity
                        entityObj[thisName] = $(this).val();
                    }
                }
            });
}


//attach all scl_array_refs to their parent scl_entity_el
function attachArrayRefData(elem) {

    // the $(elem) wrapper set must only have scl_array_ref 
    $(elem).each(function () {

        // retrieve parent entity data
        var entityObj = $(this).closest('.scl_entity_el').data('serializeForm');

        var subArrayObj = $(this).data('serializeForm');
        if (
                //// avoid []
                !$.isEmptyObject($(this).data('serializeForm'))
                //// avoid [{}] or just [{ 'view_options...' : }]
                && !($(this).data('serializeForm').length == 1
                        && ($.isEmptyObject($(this).data('serializeForm')[0])
                                || (Object.keys($(this).data('serializeForm')[0]).length == 1
                                        && Object.keys($(this).data('serializeForm')[0])[0] == 'view_options_scl_json'
                                        )
                                )
                        )
                ) {

            // attach array ref to attribute name 
            var entityName = getEntityName($(this));

            // handle when an array_ref is split across several divs (sometimes necessary in view)
            // if entityObj[entityName] already contains an array, then we just need to add to it
            if ($.isArray(entityObj[entityName])) {
                $.merge(entityObj[entityName], $(this).data('serializeForm'));
            } else {
                entityObj[entityName] = $(this).data('serializeForm');
            }

        }
    });
}

module.exports = {
    ckNameSeparator: ckNameSeparator,
    restInputSelector: restInputSelector,
    scl_modalGeneric: scl_modalGeneric,
    ckeditorConfig: ckeditorConfig,
    ckeditorConfigFullHtml: ckeditorConfigFullHtml,
    ckeditorSimpleConfig: ckeditorSimpleConfig,
    resetGlobalExitFormChanged: resetGlobalExitFormChanged,
    initRestfulForm: initRestfulForm,
    handleInputChange: handleInputChange,
    cacheClone: cacheClone,
    enableDuplicateButton: enableDuplicateButton,
    enableDeleteButton: enableDeleteButton,
    duplicateEntity: duplicateEntity,
    activateNewClone: activateNewClone,
    recursiveDepthFill: recursiveDepthFill,
    getChildrenEntityEl: getChildrenEntityEl,
    getEntityName: getEntityName,
    getRestServiceUri: getRestServiceUri,
    dummySubmit: dummySubmit,
    restfulSubmit: restfulSubmit,
    displayPopoverError: displayPopoverError,
    dynamicValidation: dynamicValidation,
    retrieveFormObject: retrieveFormObject,
    retrievePayloadObject: retrievePayloadObject,
    attachInputDataToArrayRef: attachInputDataToArrayRef,
    attachArrayRefData: attachArrayRefData,
    initRestFormPage: initRestFormPage,
    getDuplicateTargetEl: getDuplicateTargetEl
};

